import { Befehl6 } from '../../../models'
import {
  BefehlAuftrag_6_40Dto,
  BefehlAuftrag_6_41Dto,
  BefehlAuftrag_6_90Dto,
  BefehlAuftrag_6_95Dto
} from '../../../dtos'
import {
  createFreitextAuftrag,
  createFreitextField,
  createKmhField,
  createLocationField,
  createZugmeldestelleField,
  findAuftragByKennung,
  isSelectorInOrZwischen
} from '../converter-utils'
import {
  Befehl6DataDto,
  Feld_6_42_1Dto,
  Feld_6_43Dto,
  Feld_6_44Dto,
  Feld_6_47_1Dto,
  Feld_6_47_2Dto,
  Feld_6_48_1Dto,
  Feld_6_48_2Dto
} from '../../../dtos/befehl-6-dto'
import { Befehl6FormData, Befehl6FormSchema } from './schema'

export const convertModelToBefehl6FormData = (
  befehl?: Befehl6
): Befehl6FormData => {
  const formData = Befehl6FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag640 = findAuftragByKennung(befehl.auftraege, '6.40') as
    | BefehlAuftrag_6_40Dto
    | undefined
  const auftrag641 = findAuftragByKennung(befehl.auftraege, '6.41') as
    | BefehlAuftrag_6_41Dto
    | undefined
  const auftrag690 = findAuftragByKennung(befehl.auftraege, '6.90') as
    | BefehlAuftrag_6_90Dto
    | undefined
  const auftrag695 = findAuftragByKennung(befehl.auftraege, '6.95') as
    | BefehlAuftrag_6_95Dto
    | undefined

  if (auftrag640) {
    handleAuftrag_6_40(auftrag640, formData)
  }

  if (auftrag641) {
    handleAuftrag_6_41(auftrag641, formData)
  }

  if (auftrag690) {
    handleAuftrag_6_90(auftrag690, formData)
  }

  if (auftrag695) {
    handleAuftrag_6_95(auftrag695, formData)
  }

  return formData
}

function handleAuftrag_6_40(
  auftrag640: BefehlAuftrag_6_40Dto,
  formData: Befehl6FormData
) {
  // enabled not changeable by user
  formData.auftrag_6_40.enabled = true
  if (auftrag640.felder) {
    const feld643 = auftrag640.felder.find((f) => f.kennung === '6.43')
    const feld644 = auftrag640.felder.find((f) => f.kennung === '6.44')
    const feld6471 = auftrag640.felder.find((f) => f.kennung === '6.47.1')
    const feld6472 = auftrag640.felder.find((f) => f.kennung === '6.47.2')
    const feld6481 = auftrag640.felder.find((f) => f.kennung === '6.48.1')
    const feld6482 = auftrag640.felder.find((f) => f.kennung === '6.48.2')

    if (feld643 && feld644) {
      formData.auftrag_6_40.selector = 'zwischen'
    } else if (feld643) {
      formData.auftrag_6_40.selector = 'in'
    }

    if (feld643?.werte?.zugmeldestelle) {
      formData.auftrag_6_40.x_43_zugmeldestelle = {
        art: feld643.werte.zugmeldestelle.art || '',
        name: feld643.werte.zugmeldestelle.name || ''
      }
    }

    if (feld644?.werte?.zugmeldestelle) {
      formData.auftrag_6_40.x_44_zugmeldestelle = {
        art: feld644.werte.zugmeldestelle.art || '',
        name: feld644.werte.zugmeldestelle.name || ''
      }
    }

    if (feld6471?.werte) {
      formData.auftrag_6_40.x_47_type = 'km'
      formData.auftrag_6_40.x_47_1_km = feld6471.werte.km
    } else if (feld6472?.werte) {
      formData.auftrag_6_40.x_47_type = 'signal'
      formData.auftrag_6_40.x_47_2_signal = feld6472.werte.signal
    }

    if (feld6481?.werte) {
      formData.auftrag_6_40.x_48_type = 'km'
      formData.auftrag_6_40.x_48_1_km = feld6481.werte.km
    } else if (feld6482?.werte) {
      formData.auftrag_6_40.x_48_type = 'signal'
      formData.auftrag_6_40.x_48_2_signal = feld6482.werte.signal
    }
  }
}

function handleAuftrag_6_41(
  auftrag641: BefehlAuftrag_6_41Dto,
  formData: Befehl6FormData
) {
  formData.auftrag_6_41.enabled = true
  const kmhField = auftrag641.felder?.find((f) => f.kennung === '6.42.1')
  if (kmhField?.werte?.kmh) {
    formData.auftrag_6_41.x_42_1_kmh = kmhField.werte.kmh
  }
}

function handleAuftrag_6_90(
  auftrag690: BefehlAuftrag_6_90Dto,
  formData: Befehl6FormData
) {
  formData.auftrag_6_90.enabled = true
  const feld691 = auftrag690.felder?.find((f) => f.kennung === '6.91')
  const feld692 = auftrag690.felder?.find((f) => f.kennung === '6.92')

  if (feld691?.werte?.freitext) {
    formData.auftrag_6_90.x_91_freitext = feld691.werte.freitext
  }
  if (feld692?.werte?.freitext) {
    formData.auftrag_6_90.x_92_freitext = feld692.werte.freitext
  }
}

function handleAuftrag_6_95(
  auftrag695: BefehlAuftrag_6_95Dto,
  formData: Befehl6FormData
) {
  formData.auftrag_6_95.enabled = true
  const feld696 = auftrag695.felder?.find((f) => f.kennung === '6.96')
  if (feld696?.werte?.freitext) {
    formData.auftrag_6_95.freitext = feld696.werte.freitext
  }
}

export const convertBefehl6FormDataToModel = (
  data: Befehl6FormData,
  frontendId: string
): Befehl6 => {
  const auftraege: Befehl6DataDto = []

  if (data.auftrag_6_40?.enabled) {
    const felder640 = []

    if (isSelectorInOrZwischen(data.auftrag_6_40?.selector)) {
      felder640.push(
        createZugmeldestelleField(
          '6.43',
          data.auftrag_6_40?.x_43_zugmeldestelle?.art ?? '',
          data.auftrag_6_40?.x_43_zugmeldestelle?.name
        ) as Feld_6_43Dto
      )

      if (data.auftrag_6_40?.selector === 'zwischen') {
        felder640.push(
          createZugmeldestelleField(
            '6.44',
            data.auftrag_6_40?.x_44_zugmeldestelle?.art ?? '',
            data.auftrag_6_40?.x_44_zugmeldestelle?.name
          ) as Feld_6_44Dto
        )
      }
    }
    const feld647 = createLocationField(
      '6.47',
      data.auftrag_6_40?.x_47_type,
      data.auftrag_6_40?.x_47_1_km,
      data.auftrag_6_40?.x_47_2_signal
    )
    if (feld647) {
      felder640.push(feld647 as Feld_6_47_1Dto | Feld_6_47_2Dto)
    }

    const feld648 = createLocationField(
      '6.48',
      data.auftrag_6_40?.x_48_type,
      data.auftrag_6_40?.x_48_1_km,
      data.auftrag_6_40?.x_48_2_signal
    )
    if (feld648) {
      felder640.push(feld648 as Feld_6_48_1Dto | Feld_6_48_2Dto)
    }

    auftraege.push({
      kennung: '6.40',
      felder: felder640
    } as BefehlAuftrag_6_40Dto)
  }

  if (data.auftrag_6_41?.enabled) {
    const kmhField = createKmhField('6.42.1', data.auftrag_6_41?.x_42_1_kmh)
    auftraege.push({
      kennung: '6.41',
      felder: [kmhField as Feld_6_42_1Dto]
    } as BefehlAuftrag_6_41Dto)
  }

  if (data.auftrag_6_90?.enabled) {
    const felder690 = [
      createFreitextField('6.91', data.auftrag_6_90?.x_91_freitext),
      createFreitextField('6.92', data.auftrag_6_90?.x_92_freitext)
    ]

    auftraege.push({
      kennung: '6.90',
      felder: felder690
    } as BefehlAuftrag_6_90Dto)
  }

  if (data.auftrag_6_95?.enabled) {
    auftraege.push(
      createFreitextAuftrag(
        '6',
        true,
        data.auftrag_6_95?.freitext || ''
      ) as BefehlAuftrag_6_95Dto
    )
  }

  return {
    kennung: '6',
    frontendId,
    auftraege
  }
}
